import React from "react";
import cns from "classnames";
import Chip, { ChipProps } from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core";
import { ThemeType } from "@theme";

type Props = {
  classname?: string;
  style?: React.CSSProperties;
  items: ChipProps[];
};

export function ChipArray(props: Props) {
  const classes = useStyles({});

  return (
    <div className={cns(classes.root, props.classname)} style={props.style}>
      {props.items.map((chip, i) => (
        <Chip
          key={i}
          className={classes.chip}
          data-test="Chip"
          data-test-id={chip.label}
          variant="outlined"
          {...chip}
        />
      ))}
    </div>
  );
}

ChipArray.defaultProps = {
  items: []
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    display: "flex",
    padding: theme.spacing(1 / 2),
    flexWrap: "wrap"
  },

  chip: {
    height: 24,
    margin: theme.spacing(1 / 4),

    "& > svg": {
      fontSize: 18
    }
  }
}));
